import React from 'react';
import { IconButton } from '@material-ui/core';

import { IconName, Illustration } from '@klp/design/Illustrations';

import { exportTableToCSV } from '../utils/csvExport';

import type { ITableConsumerState } from './ITableConsumerState';
import { TableContext } from './TableContext';

export const TableExport = <DataType,>() => {
    const handleClick =
        (context: ITableConsumerState<DataType, unknown>) => () =>
            exportTableToCSV({
                filename: (context.exportName || context.id).concat('.csv'),
                columns: context.columns,
                data: context.data,
            });

    return (
        <TableContext.Consumer>
            {(context: ITableConsumerState<DataType, unknown>) => (
                <IconButton onClick={handleClick(context)}>
                    <Illustration icon={IconName.DOWNLOAD} size="small" />
                </IconButton>
            )}
        </TableContext.Consumer>
    );
};
